import { GlobalState } from "@app/store";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }: { children: JSX.Element }) => {
  const role = useSelector((state: GlobalState) => state.auth.role);

  return role ? <Navigate to="/home" replace /> : children;
};

export default PublicRoute;
